import React from 'react';
import './Functional_Analysis.css';

function Functional_Analysis() {
  return (
    <div className="functional-page">
      <div className="fa-toolbar">
        <div className="fa-left">
          <span className="fa-label">Select table</span>
          <button className="fa-browse">Browse</button>
          <span className="fa-selected" />
        </div>
        <div className="fa-right">
          <button className="fa-run">Run</button>
        </div>
      </div>

      <div className="fa-separator" />

      <div className="fa-panels">
        <div className="fa-panel">
          <div className="fa-panel-inner" />
        </div>
        <div className="fa-panel">
          <div className="fa-panel-inner" />
        </div>
      </div>
    </div>
  );
}

/**
 * generateFunctionalHTML
 * Returns an HTML string that matches the Functional Analysis layout.
 */
export function generateFunctionalHTML() {
  return `
    <div class="functional-page">
      <div class="fa-toolbar">
        <div class="fa-left">
          <span class="fa-label">Select table</span>
          <button class="fa-browse">Browse</button>
          <span class="fa-selected" style="margin-left:8px;color:#666;font-size:13px"></span>
        </div>
        <div class="fa-right">
          <button class="fa-run">Run</button>
        </div>
      </div>
      <div class="fa-separator"></div>
      <div class="fa-panels">
        <div class="fa-panel"><div class="fa-panel-inner"></div></div>
        <div class="fa-panel"><div class="fa-panel-inner"></div></div>
      </div>
    </div>
  `;
}

/**
 * mountFunctionalHTML
 * Inserts the generated HTML into the provided container element and wires
 * basic interactions for Browse and Run. Options may include callbacks:
 * { onRun: fn, onBrowse: fn }
 */
export function mountFunctionalHTML(container, options = {}) {
  if (!container || !(container instanceof Element)) {
    throw new Error('mountFunctionalHTML requires a DOM element as first argument');
  }

  container.innerHTML = generateFunctionalHTML();

  // create a hidden file input for Browse
  const fileInput = document.createElement('input');
  fileInput.type = 'file';
  fileInput.style.display = 'none';
  document.body.appendChild(fileInput);

  const browseBtn = container.querySelector('.fa-browse');
  const runBtn = container.querySelector('.fa-run');
  const selectedSpan = container.querySelector('.fa-selected');

  if (browseBtn) {
    browseBtn.addEventListener('click', () => fileInput.click());
  }

  fileInput.addEventListener('change', (ev) => {
    const files = ev.target.files;
    if (files && files.length > 0) {
      const names = Array.from(files).map(f => f.name).join(', ');
      if (selectedSpan) selectedSpan.textContent = names;
      if (typeof options.onBrowse === 'function') options.onBrowse(files);
    }
  });

  if (runBtn) {
    runBtn.addEventListener('click', () => {
      const selected = fileInput.files;
      if (typeof options.onRun === 'function') {
        options.onRun(selected);
      } else {
        // default behavior: log and show a brief visual cue
        console.log('Run clicked. Selected files:', selected);
        runBtn.textContent = 'Running...';
        setTimeout(() => (runBtn.textContent = 'Run'), 900);
      }
    });
  }

  return {
    fileInput,
    destroy() {
      fileInput.remove();
      if (browseBtn) browseBtn.replaceWith(browseBtn.cloneNode(true));
      if (runBtn) runBtn.replaceWith(runBtn.cloneNode(true));
      container.innerHTML = '';
    }
  };
}

export default Functional_Analysis;
